import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appToUpperCaseConditionally]',
  providers: [
    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: ToUpperCaseConditionallyDirective }
  ]
})
export class ToUpperCaseConditionallyDirective extends DefaultValueAccessor {

  @Input() toUpperCaseEnabled: boolean;
  private elementRef: ElementRef;

  constructor(renderer: Renderer2, elementRef: ElementRef) {
    super(renderer, elementRef, false);
    this.elementRef = elementRef;
  }

  writeValue(value: any): void {
    super.writeValue(this.transformValue(value));
  }

  @HostListener('input', ['$event'])
  onInput(value: any): void {
    if (this.toUpperCaseEnabled) {
      const pos = this.elementRef.nativeElement.selectionStart;
      const transformed = this.transformValue(value.target.value);
      super.writeValue(transformed);
      this.elementRef.nativeElement.setSelectionRange(pos, pos, 'none');
      this.onChange(transformed);
    }
  }

  @HostListener('blur', ['$event'])
  onBlur() {
    if (this.toUpperCaseEnabled) {
      this.onTouched();
    }
  }

  transformValue(value: any): any {
    if (!value || typeof value !== 'string') {
      return value;
    }

    const res = [];
    for (const ch of value) {
      res.push(ch === 'ß' ? ch : ch.toUpperCase());
    }
    return res.join('');
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }
}
